var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"datetime":_vm.utc,"title":_vm.tooltip}},[_vm._v(_vm._s(_vm.prefix + _vm.formatted + _vm.suffix))])
}
var staticRenderFns = []

export { render, staticRenderFns }